import React from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ArcElement
} from "chart.js";
import NoDataFound from '../../NoDataFound/NoDataFound';
import ChartFormatIndianNumber from "../../../Common/ChartFormatIndianNumber";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ArcElement
);

const formatLabel = (key) => {
  return key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const CategoryPerformanceDashboard = ({ chartData = [] }) => {
  if (!Array.isArray(chartData) || chartData.length === 0) {
    return <NoDataFound height={300} />;
  }

  const dataObject = chartData[0];
  const entries = Object.entries(dataObject);
  const labels = entries.map(([key]) => formatLabel(key));
  const values = entries.map(([_, value]) =>
    typeof value === "string" && value.includes("%")
      ? parseFloat(value)
      : value
  );

  const barData = {
    labels,
    datasets: [
      {
        label: "Performance",
        data: values,
        backgroundColor: [
          "#d35400",
          "#c0399f",
          "#2aa6c4",
          "#f39c12",
          "#1abc9c",
          "#8e44ad",
          "#76eec6",
          "#ec407a",
          "#ec7063"
        ],
        borderRadius: 50,
        categoryPercentage: 0.6,
        barPercentage: 1
      }
    ]
  };

  const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false
    },
    plugins: {
      tooltip: {
        mode: 'index',
        intersect: false,
        callbacks: {
          label: (context) =>
            context.formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
      },
      legend: { display: false },
      datalabels: {
        display: false
      }
    },
    scales: {
      y: {
        title: {
          display: true,
        },
        ticks: {
          callback: (value) => ChartFormatIndianNumber(value).toLocaleString()
        },
        beginAtZero: true
      },
      x: {
        ticks: {
          maxRotation: 0,
          minRotation: 0
        }
      }
    }
  };

  const adsSales = dataObject.ads_sales || 0;
  const totalSales = dataObject.total_sales || 1;
  const adsSalesPercent = ((adsSales / totalSales) * 100).toFixed(1);

  const doughnutData = {
    labels: ["Ads Sales", "Other Sales"],
    datasets: [
      {
        data: [adsSales, totalSales - adsSales],
        backgroundColor: ["#00cfe8", "#e0e0e0"],
        borderWidth: 0,
        cutout: "75%"
      }
    ]
  };

  const doughnutOptions = {
    cutout: "75%",
    plugins: {
      tooltip: { enabled: true },
      legend: { display: false },
      datalabels: {
        display: false
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "1rem",
        justifyContent: "space-between",
        alignItems: "stretch",
      }}
    >
      {/* Bar Chart */}
      <div
        style={{
          flex: "1 1 65%",
          minWidth: "300px",
          height: "400px"
        }}
      >
        <Bar data={barData} options={barOptions} />
      </div>

      {/* Doughnut Chart */}
      <div
        style={{
          flex: "1 1 30%",
          minWidth: "240px",
          height: "400px",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Doughnut data={doughnutData} options={doughnutOptions} />
        <div
          style={{
            position: "absolute",
            fontSize: "clamp(16px, 4vw, 28px)",
            fontWeight: "bold",
            textAlign: "center"
          }}
        >
          {adsSalesPercent}%
        </div>
      </div>
    </div>
  );
};

export default CategoryPerformanceDashboard;
